import { useQuery } from "@tanstack/react-query";
import Axios from "axios";

const useUserLetterStatusQuery = (moveinInfoId) => {
  return useQuery({
    queryKey: ["letter-status-user", moveinInfoId],
    queryFn: () => {
      if (!moveinInfoId) return;
      return Axios.get(
        `${process.env.REACT_APP_BASE_URL}/moveinInfo/letter-printed/${moveinInfoId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      ).then((res) => res?.data?.data);
    },
    enabled: !!moveinInfoId,
  });
};

export default useUserLetterStatusQuery;
